import React, { useEffect, useState } from 'react'
import styled from 'styled-components';
import { ConfirmIcon } from '../../components/Icons/ConfirmIcon';
import { Modal, ModalContent } from '../../components/Modal/Modal';
import { useAccount } from 'wagmi';
import { Contract } from 'ethers/lib/ethers';
import { ErrorIcon } from '../../components/Icons/ErrorIcon';
import { BootyABI } from '../../constants/ABI/BootyABI';
import { BOOTY_ADDRESS, OLD_BOOTY_ADDRESS } from '../../constants/addresses';
import { Spinner } from '../../components/Loaders';
import { artifacts, crates, itemsMap } from './Items';
import { breakpoints, Media } from '../../styles';
import { useWidthBreakpoint } from '../../hooks';
import toast from 'react-hot-toast';
import { useEthersProvider, useEthersSigner } from '@/utils/wagmi-ethers-adapters/ethers';

interface ConfirmMigrateProps {
  visible: boolean,
  setVisible: (visible: boolean) => void,
  migrateAmounts: Record<string, string>,
  setMigrateAmounts: (amounts: Record<string, string>) => void,
  updateBalances: any
}

export const ConfirmMigrate = ({ visible, setVisible, migrateAmounts, setMigrateAmounts, updateBalances }: ConfirmMigrateProps) => {
  const isTablet = useWidthBreakpoint(breakpoints.tablet)
  const { address: walletAddress } = useAccount(); 
  
  const { data: signer } = useEthersSigner();
  const provider = useEthersProvider();

  const [approvalState, setApprovalState] = useState('')
  const [confirmDisabled, setConfirmDisabled] = useState(false)
  const [txState, setTxState] = useState('')

  const oldBooty = new Contract(OLD_BOOTY_ADDRESS, BootyABI, signer || provider)
  const booty = new Contract(BOOTY_ADDRESS, BootyABI, signer || provider)

  const rowLength = 5;
  const artifactRows = []

  for (let i = 0; i < Object.keys(migrateAmounts).length; i += rowLength) {
    artifactRows.push(Object.keys(migrateAmounts).slice(i, i + rowLength))
  }

  const approve = () => {
    setApprovalState('Pending')
    oldBooty.setApprovalForAll(booty.address, true).then((response: any) => {
        toast.promise(response.wait(), {
            loading: "Approving BKB",
            success: () => {
                setApprovalState('');
                return "Approved BKB";
            },
            error: () => {
                setApprovalState('');
                return (
                    "Error in BKB approval"
                );
            },
        });
    })
  }

  const executeTransaction = () => {
    if (signer) {
      setConfirmDisabled(true)
      setTxState('Pending')
    
      const ids = Object.keys(migrateAmounts).map((artifactID) => parseInt(artifactID))
      const amounts = Object.values(migrateAmounts).map((amount) => parseInt(amount))

      booty.migrate(ids, amounts).then((response: any) => {

        setTxState('Submitted')

        response.wait().then((result: any) => {
          if (result.status == 1) { //Success

            setTxState('Success')

            window.location.reload()

          } else {
            setTxState('Error')
          }
          setConfirmDisabled(false);
        })
      }).catch(() => {
        setTxState('')
        setConfirmDisabled(false);
      });
      
    }
  }

  useEffect(() => {
    oldBooty.isApprovedForAll(walletAddress, booty.address).then((approved: any) => {
        if(!approved){
            setApprovalState('Needs')
        }
    })
  }, [walletAddress])

  return (
    <StyledModal
      title={txState ? `Migration ${txState}` : 'BKB Migration'}
      isVisible={visible}
      onClose={() => {
        setVisible(false)
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '16px'}}>
        <Label style={{ color: '#7D7D97' }}>To migrate</Label>
        <MigratedArtifactsColumn>
          {artifactRows.map((artifactRow) => {
            return (
              <Row style={{gap: '4px', justifyContent: 'start'}} key={artifactRow.toString()}>
                {artifactRow.map((artifactID: any) =>
                  <Artifact key={artifactID}>
                    <img src={`../../assets/booty/${itemsMap[parseInt(artifactID)].image}.jpg`} />
                    <ArtifactBalance>{parseInt(migrateAmounts[artifactID]) > 99 ? '99+' : migrateAmounts[artifactID]}</ArtifactBalance>
                  </Artifact>
                )}
              </Row>
            )
          })}
        </MigratedArtifactsColumn>
      </div>
      {txState && txState != 'Error' && (
        <CircleContainer>
          {txState == 'Success' ? <ConfirmIcon /> : <Spinner />}
        </CircleContainer>
      )}
      {
        txState == 'Error' ? (
          <Error>
            <ErrorIcon />
            Migration Error
          </Error>
        ) : (txState == 'Submitted' || txState == 'Success' ? (
          <Label style={{ margin: '0px auto', color: '#7D7D97' }}>
            {txState == 'Submitted' ? 'Waiting for blockchain confirmation...' : 'Confirmation success!'}
          </Label>
        ) : (
          <>
            {approvalState ?
              <ActionButton onClick={approve} disabled={approvalState == 'Pending'}>
                <ConfirmIcon />
                Approve
              </ActionButton> 
              :
              <ActionButton onClick={executeTransaction} disabled={confirmDisabled}>
                <ConfirmIcon />
                Confirm Migration
              </ActionButton>
            }    
          </>
        ))
      }
    </StyledModal>
  )
}

const StyledModal = styled(Modal)`
  height: fit-content;
  max-width: 724px;

  ${ModalContent} {
    overflow: unset;
  }

  ${Media.mobile} {
    height: 95%;
    max-width: 100%;
    margin-top: 5.5%;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }
`;

const MigratedArtifactsColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: fit-content;
  max-width: 100%;
  flex-wrap: wrap;
  gap: 8px;
  margin: 12px auto 0;
  justify-content: center;

`

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  font-weight: 10;
  font-size: 20px;
  letter-spacing: -0.03em;
  color: #FFFFFF;
`;

const Label = styled.p<{ total?: boolean }>`
  font-weight: 500;
  font-size: 14px;
  text-align: left;
  white-space: nowrap;
  letter-spacing: -0.02em;
  color: ${({ total }) => total ? '#00BDFF' : '#FFFFFF'};
`;

const CircleContainer = styled.div`
  width: 74px;
  height: 74px;
  margin: 0px auto 16px auto;
  color: #00BDFF;

  ${Media.smallMobile}{
    width: 56px;
    height: 56px;
  }
`

const Artifact = styled.div`
  width: 64px;
  height: 64px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    border-radius: 16px;
    border: solid 2px #1E2239;
  } 

  ${Media.smallMobile}{
    width: 48px;
    height: 48px;
  }
`

const ArtifactBalance = styled.p`
  position: absolute;
  min-width: 24px;
  min-height: 24px;
  font-weight: 10;
  font-size: 10px;
  line-height: 24px;
  text-align: center;
  margin-top: 34px;
  margin-left: 34px;

  border-radius: 12px;
  background: #00BDFF;
  color: #1E2239;
`

const ActionButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 264px;
  height: 76px;
  margin: auto;
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  color: #0a0e27;
  background: linear-gradient(90.44deg, #37dcf2 0.87%, #07c0fb 100%);
  border-radius: 16px;

  svg {
    height: 28px;
    width: 28px;
    margin-right: 8px;
    color: #464659;
  }

  &:not(:disabled) svg path {
    fill: #151530;
  }

  &:disabled {
    background: #0a0e27;
    color: #464659;
    border: solid 2px #464659;
  }

  ${Media.tablet} {
    height: 66px;
    margin-top: auto;
  }
`;

const Error = styled(ActionButton)`
    background: linear-gradient(90.44deg, #fb0740 0.87%, #fb0707 100%);
    pointer-events: none;
`